// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","item":"styles_item__QbrH8"};